// trainingService.js
import api from "Common/Client/Interceptor";
import { toArray } from "Common/utils/list";

export const fetchTrainingGroupData = async (adminId, token) => {
  try {
    // The old FormGroup/Information wrapper was split into two paginated
    // endpoints (training requests and mentors).
    const headers = { Authorization: `Bearer ${token}`, Accept: "*/*" };
    const [requestsRes, mentorsRes] = await Promise.all([
      api.get(`/TrainingGroup/FormGroup/TrainingRequests/List`, {
        params: { pageNumber: 1, pageSize: 30, orderByLatest: false },
        headers,
      }),
      api.get(`/TrainingGroup/FormGroup/Mentors/List`, {
        params: { pageNumber: 1, pageSize: 30, orderByLatest: false },
        headers,
      }),
    ]);

    return {
      learners: requestsRes.data.items || [],
      mentors: mentorsRes.data.items || [],
    };
  } catch (error) {
    console.error("Error fetching training group data:", error.response?.data || error);
    return { learners: [], mentors: [] };
  }
};

export const fetchTeamsByMentor = async (mentorId, token) => {
  try {
    const response = await api.get(`/TrainingGroup/TeamNames/List?mentorId=${mentorId}&pageNumber=1&pageSize=30`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
    return toArray(response.data);
  } catch (error) {
    console.error("Error fetching teams:", error.response?.data || error);
    return [];
  }
};

// trainingService.js
export const createTrainingGroup = async (groupData, token) => {
  try {
    const response = await api.post("/TrainingGroup/Create", groupData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error
  }
};

export const fetchTrainingDetail = async (adminId, token, { pageNumber = 1, pageSize = 10, orderByLatest = false } = {}) => {
  try {
    const response = await api.get(
      `/TrainingGroup/Admin/List?AdminId=${adminId}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderByLatest=${orderByLatest}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
